<template>
  <v-dialog v-model="dialog" width="800px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Đối soát trả hàng</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-4 mb-4">
            <CardStudentInfo :student="uniformOrderData.student" link />
          </v-col>
        </v-row>
        <div class="fix-height-dialog-review">
          <v-row>
            <v-col cols="12">
              <v-divider />
              <div class="mt-4 mb-1">
                <span style="font-weight: bold">Danh sách đồng phục</span>
              </div>
            </v-col>

            <v-col v-for="(item, index) in uniformItems" :key="index" cols="12" class="mb-2 pt-0 pb-0">
              <v-card outlined class="pa-3">
                <v-row align="center">
                  <v-col cols="6">
                    <div>{{ item.name }} - {{ item.optionOne }} - {{ item.optionTwo }}</div>
                    <div>Số lượng đặt: {{ item.quantity }}</div>
                  </v-col>
                  <v-col cols="3">
                    <div>Đã trả ({{ item.returned }}/{{ item.quantity }})</div>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model.number="item.returnAdditional"
                      :label="'Số lượng trả thêm'"
                      type="number"
                      min="0"
                      :max="item.quantity - item.returned"
                      :disabled="item.quantity - item.returned === 0"
                      outlined
                      dense
                      hide-details
                      @input="validateReturnQuantity(item)"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider />

      <!-- Nút hành động -->
      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn outlined color="grey" @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="confirmUpdate">LƯU </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import CardStudentInfo from '@/components/basic/card/CardStudentInfo.vue'
import moment from 'moment'

export default {
  components: {
    CardStudentInfo,
  },
  props: {
    state: Boolean,
    uniformOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      uniformItems: [],
    }
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['updateUniformOrders']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    validateReturnQuantity(item) {
      const maxReturnable = item.quantity - item.returned
      if (item.returnAdditional > maxReturnable) {
        item.returnAdditional = maxReturnable
      }
    },
    // getNextRoundNumber(item) {
    //   if (!item.returnHistory || item.returnHistory.length === 0) {
    //     return 1
    //   }
    //   const maxRound = Math.max(...item.returnHistory.map(entry => (entry.round !== undefined ? entry.round : 0)))
    //   return maxRound + 1
    // },
    // getNextRoundNumber() {
    //   const allRounds = this.uniformItems.flatMap(item => item.returnHistory.map(history => history.round))

    //   const validRounds = allRounds.filter(round => typeof round === 'number')

    //   return validRounds.length > 0 ? Math.max(...validRounds) + 1 : 1
    // },
    getNextRoundNumber() {
      const allValidRounds = this.uniformItems
        .flatMap(item => item.returnHistory.filter(history => !history.isDeleted).map(history => history.round))
        .filter(round => typeof round === 'number')

      return allValidRounds.length > 0 ? Math.max(...allValidRounds) + 1 : 1
    },

    async confirmUpdate() {
      this.$loading.active = true
      try {
        const nextRound = this.getNextRoundNumber()
        const updatedItems = this.uniformItems.map(item => {
          const returnQuantity = Math.min(item.returnAdditional, item.quantity - item.returned)

          if (returnQuantity === 0) {
            return { ...item }
          }

          const historyEntry = {
            quantity: returnQuantity,
            round: nextRound,
            date: new Date(),
            notes: `Trả hàng vào ${this.formatDate(new Date())}`,
            isDeleted: false,
          }
          console.log(historyEntry)

          return {
            ...item,
            returned: item.returned + returnQuantity,
            returnHistory: [...item.returnHistory, historyEntry],
          }
        })

        const statusReturned = updatedItems.every(item => item.returned >= item.quantity)
          ? 'complete_returned'
          : 'waiting_returned'

        const newStatus = this.uniformOrderData.status === 'pending' ? 'confirmed' : this.uniformOrderData.status

        const updatePayload = {
          id: this.uniformOrderData.id,
          status: newStatus,
          statusReturned,
          uniformItems: updatedItems,
        }

        await this.updateUniformOrders(updatePayload)
        this.$alert.addSuccess('Cập nhật đối soát thành công!')
        this.$emit('updated')
        this.dialog = false
      } catch (error) {
        this.$alert.addError('Có lỗi xảy ra khi cập nhật đối soát!')
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    },
  },
  watch: {
    state(val) {
      if (val) {
        if (this.uniformOrderData.status === 'pending') {
          this.$alert.error('Vui lòng duyệt đơn trước khi thực hiện đối soát trả đồng phục')
          this.dialog = false
          return
        } else if (this.uniformOrderData.status === 'cancelled') {
          this.$alert.error('Vui lòng không thực hiện đối soát trả đồng phục đối với đơn đã huỷ')
          this.dialog = false
          return
        }
        this.dialog = true
        this.uniformItems = this.uniformOrderData.uniformItems.map(item => ({
          ...item,
          returnAdditional: 0,
        }))
      }
    },
  },
}
</script>

<style scoped>
.order-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.item-wrapper {
  display: flex;
  justify-content: space-between;
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 8px;
}

.item-name {
  font-size: 14px;
}

.item-quantity {
  display: flex;
  align-items: center;
  gap: 5px;
}
.fix-height-dialog-review {
  height: 400px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  box-sizing: border-box;
}
</style>
